import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector } from "react-redux";

export default function CasesInfo({ caseInfo, caseInfoId, setCaseInfo }) {
  const data = useSelector(
    (state) => state.main.data?.instructionsData
  )?.filter((item) => item.id == caseInfoId)?.[0];

  return (
    caseInfo && (
      <div className="cases-info" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setCaseInfo(false)}
        ></div>
        <div className="container ">
          <div className="image">
            <img
              src={`https://api.atharalfarasha.com/public/hakim/${data?.instructions_photo_2}`}
              alt=""
            />
            <div className="title">{data?.instruction_name}</div>
          </div>
          <div className="texts">
            {data?.instruction_text.split("\n").map(
              (text) =>
                text !== "" && (
                  <div className="text">
                    <span>{text}</span>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    )
  );
}
